/**
 * Created by Viktor on 2016.09.01..
 */
$(function(){
    var cookie = Cookies.get('ws-popup');
    if(!cookie) {
        setTimeout(showPopUp, 5000);
        Cookies.set('ws-popup', true, {expires: 30});
    }
});

function showPopUp(){
    $('.ws-popup').modal('show');
}